module.exports = __webpack_public_path__ + "img/ii_toolkit-poster.9e4cf104.jpg";